(function($, window, undefined) {
	function ApartmentPricing(args) {
		this.swiper;
		this.defaults = {
			selectors: {
				widgetContainer: "[data-apartment-slider]",
				swiperContainer: "[data-apartment-swiper-container]",
				btnNext: "[data-apartment-swiper-next]",
				btnPrev: "[data-apartment-swiper-prev]",

				popUpForm: "[data-popup-form]",
				roomForm: "[data-room-form]",
				apartmentForm: "[data-apartment-form]",
				closeBtn: "[data-popup-form-close]",
				roomBtn: "[data-room-btn]",
				apartmentBtn: "[data-apartment-btn]",
			},
			classes: {
				showPopUpForm: "show-form",
				hideFormContent: "form-hidden",
			},
		};

		this.options = $.extend(true, {}, this.defaults, args);

		this.$widgetContainer = $(this.options.selectors.widgetContainer);
		this.$swiperContainer = this.parent(this.options.selectors.swiperContainer);
		this.$btnNext = this.parent(this.options.selectors.btnNext);
		this.$btnPrev = this.parent(this.options.selectors.btnPrev);

		this.$popUpForm = this.parent(this.options.selectors.popUpForm);
		this.$roomForm = this.parent(this.options.selectors.roomForm);
		this.$apartmentForm = this.parent(this.options.selectors.apartmentForm);
		this.$closeBtn = this.parent(this.options.selectors.closeBtn);
		this.$roomBtns = this.parent(this.options.selectors.roomBtn);
		this.$apartmentBtns = this.parent(this.options.selectors.apartmentBtn);

		this.slidesPerView = this.$widgetContainer.attr("data-apartment-slider");
		this.init(this.slidesPerView);
	}

	/**
	 * Returns a jQuery element that is a child of the parent element
	 * @param selector
	 * @returns {*|HTMLElement}
	 */
	ApartmentPricing.prototype.parent = function(selector) {
		return $(selector, this.$widgetContainer);
	};

	ApartmentPricing.prototype.init = function(slidesPerView) {
		var self = this;
		var options = {
			centeredSlides: true,
			centeredSlidesBounds: true,
			loop: false,
			slidesPerView: 1,
			noSwiping: false,
			allowSlideNext: true,
			allowSlidePrev: true,
			freeMode: false,
			grabCursor: true,
			spaceBetween: 30,
			slidesOffsetBefore: 0,
			slidesOffsetAfter: 0,

			breakpoints: {
				992: {
					slidesPerView: 3,
				},
			},

			// Navigation arrows
			navigation: {
				nextEl: this.$btnNext,
				prevEl: this.$btnPrev,
			},
		};

		switch (slidesPerView) {
			case "1":
				options.freeMode = false;
				options.grabCursor = false;
				options.noSwiping = true;
				options.allowSlideNext = false;
				options.allowSlidePrev = false;
				options.slidesPerView = 1;
				options.breakpoints = {
					992: {
						slidesPerView: 1,
					},
				};
				break;

			case "2":
				options.breakpoints = {
					768: {
						freeMode: false,
						grabCursor: false,
						noSwiping: true,
						allowSlideNext: false,
						allowSlidePrev: false,
						slidesPerView: 2,
					},
					992: {
						freeMode: false,
						grabCursor: false,
						noSwiping: true,
						allowSlideNext: false,
						allowSlidePrev: false,
						slidesPerView: 2,
					},
				};
				break;

			case "3":
				options.breakpoints = {
					992: {
						freeMode: false,
						grabCursor: false,
						noSwiping: true,
						allowSlideNext: false,
						allowSlidePrev: false,
						slidesPerView: 3,
					},
				};
				break;
		}

		this.swiper = new Swiper(self.$swiperContainer, options);

		this.$roomBtns.on("click", function() {
			self.$popUpForm[0].classList.add(self.options.classes.showPopUpForm);
			self.$apartmentForm[0].classList.add(self.options.classes.hideFormContent);
			self.$roomForm[0].classList.remove(self.options.classes.hideFormContent);
		});

		this.$apartmentBtns.on("click", function() {
			self.$popUpForm[0].classList.add(self.options.classes.showPopUpForm);
			self.$roomForm[0].classList.add(self.options.classes.hideFormContent);
			self.$apartmentForm[0].classList.remove(self.options.classes.hideFormContent);
		});

		this.$closeBtn.on("click", function() {
			self.$popUpForm[0].classList.toggle(self.options.classes.showPopUpForm);
		});

		this.updateScroll();

		$(window).resize(function() {
			self.updateScroll();
		});
	};

	ApartmentPricing.prototype.updateScroll = function() {
		var self = this;
		var height = $(window).height();
		// 702 is the min-height required for the form to display all fields
		if (height < 702) {
			self.$popUpForm[0].classList.add("overflow-scroll");
		} else {
			self.$popUpForm[0].classList.remove("overflow-scroll");
		}
	};

	window.SVHA = window.SVHA || {};
	window.SVHA.Widgets = window.SVHA.Widgets || {};
	window.SVHA.Widgets.ApartmentPricing = ApartmentPricing;
})(jQuery, window);
